import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import "./../../View.css";
import "./../../Grid.css";
import "./../../Form.css";
import "./../../App.css";
import EnhancedTable from '../../widgets/ResponsiveTable';
import EnhancedToolbar from '../../widgets/Toolbar';
import AlertItem from "../../widgets/AlertItem";
import Prompt from '../../widgets/Prompt';
import ViewUtils from '../../ViewUtils';
import { ViewContainer } from "./../../View.jsx";
import FormDialog from "../FormDialog";
import { AssessorForm } from "../assessor/AssessorForm";
import AssessorSearch from "../assessor/AssessorSearch";
import LinkDialog from "../LinkDialog";
import { ProviderAssessorAssessmentEndDateForm } from "../provider/ProviderAssessorAssessmentEndDateForm";

const headCells = [
    { id: 'FirstName', numeric: false, disablePadding: false, label: 'First Name' },
    { id: 'Surname', numeric: false, disablePadding: false, label: 'Surname' },
    { id: 'IdNumber', numeric: false, disablePadding: false, label: 'ID Number' },
    { id: 'RegistrationNumber', numeric: false, disablePadding: false, label: 'Registration Number' },
    { id: 'RegistrationEndDate', numeric: false, disablePadding: true, label: 'Registration End Date' },
    { id: 'AssessmentEndDate', numeric: false, disablePadding: true, label: 'Assessment End Date' }
];

const utils = new ViewUtils();
const toolbarRef = React.createRef();
const addFormRef = React.createRef();
const updateFormRef = React.createRef();


class ProviderAssessorSearch extends Component {

    constructor(props) {
        super(props)
        this.state = {
            linkDialogOpen: false,
            formDialogOpen: false,
            selectedAssessor: null,
            selectedPerson: null,
            updateDateformDialogOpen: false,
            propmtOpen: false,
            promptTitle: "Remove Assessor from Provider",
            promptContent: "Are you sure you want to remove this assessor from the provider?",
            removeMessage: "",
            removeMessageStyle: "",
            searchParameters: [{ Name: "providerID", Value: this.props.location.state.selection }]
        }

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'close', label: 'CLOSE', tooltip: 'Close', icon: 'CloseIcon' }
                    ]
                }
                ,
                {
                    type: "devider"
                },
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: "link", label: '', icon: 'LinkIcon', tooltip: "Link existing Assessor to provider" },
                        {
                            id: 'view', label: '', icon: 'ViewIcon', tooltip: 'View Selected Assessor Details',
                            disabled: utils.isNull(this.state.selectedAssessor)
                        },
                        {
                            id: 'remove', label: '', icon: 'DeleteIcon', tooltip: 'Remove assessor from provider',
                            disabled: utils.isNull(this.state.selectedAssessor)
                        },
                        {
                            id: 'updateDate', label: 'Update Registration End Date', tooltip: 'Update Registration End Date',
                            disabled: utils.isNull(this.state.selectedAssessor)
                        }
                    ]
                }
            ]
        };

    }
    handleToolbarButtonClick(buttonId) {
        if ("close" === buttonId) {
            this.props.history.push({
                pathname: '/provider',
                state: { selection: this.props.location.state.selection }
            });
        }
        else if ("remove" === buttonId) {
            this.setState({ promptOpen: true })
        }
        else if ("view" === buttonId) {
            this.setState({ removeMessage: "" }, this.viewLearner());
        }
        else if ("link" === buttonId) {
            this.setState({ linkDialogOpen: true, removeMessage: "" })

        }
        else if ("updateDate" === buttonId) {
            this.setState({ updateDateDialogOpen: true, message: "" })

        }
    }

    dialogActionHandler(isCancel, added) {
        if (added === true) {
            this.setState({
                searchParameters: JSON.parse(JSON.stringify(this.state.searchParameters)),
                formDialogOpen: false, updateDateDialogOpen: false, selectedSiteVisit: null, linkDialogOpen: false
            });
        }
        else if (isCancel === true) {
            this.setState({
                formDialogOpen: false,
                linkDialogOpen: false,
                updateDateDialogOpen: false
            })
        }
    }

    dialogUpdateActionHandler(isCancel, added) {
        if (added === true) {
            this.setState({
                searchParameters: JSON.parse(JSON.stringify(this.state.searchParameters)),
                formDialogOpen: false, updateDateDialogOpen: false, selectedSiteVisit: null, linkDialogOpen: false
            });
        }
        else if (isCancel === true) {
            this.setState({
                formDialogOpen: false,
                linkDialogOpen: false,
                updateDateDialogOpen: false
            })
        }
    }

    handleSelectionChange = (selection) => {
        if (selection !== null && selection.length !== 0) {
            this.setState({ selectedAssessor: selection[0].Id, removeMessage: "", selectedPerson: selection[0].AssessorID });
        }
        else {
            this.setState({ selectedAssessor: null, removeMessage: "", selectedPerson: null });
        }
        toolbarRef.current.setButtonDisabled("remove", selection === null || selection.length === 0);
        toolbarRef.current.setButtonDisabled("view", selection === null || selection.length === 0);
        toolbarRef.current.setButtonDisabled("updateDate", selection === null || selection.length === 0);
    }

    successfulRemoveCallback = (response) => {

        if (!utils.isNull(response.EntityId) && response.EntityId === 0) {
            this.setState({
                selectedAssessor: null, removeMessage: response.Message,
                removeMessageStyle: response.MessageType.toLowerCase()
            });
            //Force a refresh
            this.setState({ searchParameters: JSON.parse(JSON.stringify(this.state.searchParameters)) })
        }
    }

    unsuccessfulRemoveCallback = (response) => {
        if (!utils.isNull(response.Message) && response.Message !== "") {
            this.setState({
                removeMessage: response.Message,
                removeMessageStyle: response.MessageType.toLowerCase()
            })
        }
    }

    removeAssessors(url) {
        this.setState({ promptOpen: false }, () => {
            toolbarRef.current.setButtonDisabled("remove", true);
        })

        let fullUrl = `${url}?id=${this.state.selectedAssessor}&providerId=${this.props.location.state.selection}`;
        utils.invokeUrlDelete(fullUrl, this.successfulRemoveCallback, this.unsuccessfulRemoveCallback);
    }

    viewLearner = () => {
        this.setState({ formDialogOpen: true })
    }


    closePrompt = () => {
        this.setState({ propmtOpen: false })
    }

    render() {
        return (
            <ViewContainer mode={this.props.mode} title="">

                <p className="breadcrumbs">
                    {"Provider > Assessors " + (this.props.location.state.providerName !== null ? "> " + this.props.location.state.providerName + (this.props.location.state.providerSDLNumber !== null ? " - " + this.props.location.state.providerSDLNumber : "") : "> Add")}
                </p>

                <AlertItem message={this.state.removeMessage} alertStyle={this.state.removeMessageStyle} />

                <div className="searchResults">
                    <EnhancedToolbar
                        highlight={false}
                        buttonClickHandler={(buttonId) => this.handleToolbarButtonClick(buttonId)}
                        ref={toolbarRef}
                        config={this.toolbarConfig} />

                    <EnhancedTable
                        headCells={headCells}
                        dataUrl={`api/sims/providerassessor/GetProviderAssessor`}
                        height="60vh"
                        onSelectionChange={(selection) => { this.handleSelectionChange(selection) }}
                        searchParameters={this.state.searchParameters} paged={true} />
                </div>

                <FormDialog
                    open={this.state.formDialogOpen}
                    dialogTitle={"View Provider Assessor Details"}
                    viewRef={this}
                    formRef={addFormRef}
                    isView={true}
                    closeHandler={(isCancelled, linked) => this.dialogActionHandler(isCancelled, linked)}
                >
                    <AssessorForm
                        ref={addFormRef}
                        id={this.state.selectedPerson}
                        disableFields={true}
                    />
                </FormDialog>

                <FormDialog
                    open={this.state.updateDateDialogOpen}
                    dialogTitle={"Update Assessment End Date"}
                    viewRef={this}
                    entityId={this.state.selectedAssessor}
                    formRef={updateFormRef}
                    usePut={true}
                    saveUrl={"api/sims/providerassessor/UpdateAssessmentEndDate"}
                    closeHandler={(isCancelled, linked) => this.dialogUpdateActionHandler(isCancelled, linked)}
                >
                    <ProviderAssessorAssessmentEndDateForm ref={updateFormRef} id={this.state.selectedAssessor} dataURL='api/sims/providerassessor/GetFindAssessmentEndDate' controllerName='providerassessor' />
                </FormDialog>

                <LinkDialog open={this.state.linkDialogOpen} type={this.state.selectedLinkType}
                    closeHandler={(isCancelled, linked) => this.dialogActionHandler(isCancelled, linked)}
                    dialogTitle={`Link Assessors to Provider > ${this.props.location.state.providerName} - ${this.props.location.state.providerSDLNumber}`}
                    linkName={"assessors"} postUrl={"api/sims/providerassessor/LinkProviderAssessor"} usePost={true}
                    selectionId={this.props.location.state.selection}
                >
                    <AssessorSearch
                        dataUrl={"api/sims/providerassessor/GetSearchLinkableAssessors"}
                        multiSelect={true} showTitle={false}
                        programmeId={this.props.location.state.selection} programmeType="Q"
                        mode="lookup"
                    />
                </LinkDialog>

                <Prompt open={this.state.promptOpen}
                    promptTitle={this.state.promptTitle}
                    promptContent={this.state.promptContent}
                    handleYes={() => { this.removeAssessors("api/sims/providerassessor/RemoveProviderAssessor") }}
                    closePrompt={this.closePrompt}
                />
            </ViewContainer>
        );
    }
}

export default withRouter(
    connect()(ProviderAssessorSearch)
);
